<template>
  <div id="app">
    <div class="row">
      <Logo_ACU class="col-md-2"></Logo_ACU>
      <Logo_IMA class="col-md-2 mt-1"></Logo_IMA>
      <!--  <Data_User>...</Data_User> -->
    </div>
    <router-view />
  </div>
</template>

<script>
/* import { mapState } from "vuex"; */
import Logo_ACU from "@/components/Logo_ACU";
import Logo_IMA from "@/components/Logo_IMA";
/* import Data_User from "@/components/Data_User"; */

export default {
  components: {
    Logo_ACU,
    Logo_IMA,
    /*   Data_User, */
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif, Segoe Script;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  max-width: 1000px;
  min-height: 100vh;
  min-height: -webkit-fill-available;

  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  margin: 0 auto;
  background-color: #c2c2c2;
  /*  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center; */
}

.row {
  height: 15vh;
  background-color: #fff;
}
.home {
  height: 80vh;
  background-color: #fff;
}
</style>
